import { Utils } from "@/plugins/utils";
import router from '@/router';

export default {
	namespaced: true,
	state: {
		lstCv1: [],
		cv1: {
			cv1docfis: "",
			cv1modelo: "",
		},
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false
	},
	getters: {
		getCv1modelo: state => state.cv1.cv1modelo ?? "",
	},
	mutations: {
		setCv1modelo: (state, cv1modelo) => state.cv1.cv1modelo = cv1modelo,
		set(state, cv1){
			state.cv1 = cv1
			if (cv1)
				state.update = true
		},
		initForm(state){
			state.insert = false
			state.update = false
			state.cv1 = null
		},
		setParamsDataTable(state, payload){
			state.lstCv1 = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
	},
	actions: {
		initForm(store){
			store.commit("initForm")
		},
		async get(store, cv1docfis){
			return await this._vm.$axios.get(`/Oryx/FiscalDocumentType/Find/${cv1docfis}`)
			.then(response => {
				return Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return null
			});
		},
		async find(store, cv1docfis){
			store.state.loading = true
			store.commit("initForm")
			await store.dispatch("get", cv1docfis)
			.then(cv1 => {
				store.commit("set", cv1)
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
			});
			store.state.loading = false
		},
		save(store){
			if (store.state.update){
				store.dispatch("update")
				return
			}
			store.dispatch("insert")
		},
		async insert(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
			await this._vm.$axios.post("/Oryx/FiscalDocumentType/Insert", store.state.cv1 )
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/documentos-fiscais")
				store.state.cv1 = null
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async update(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
			await this._vm.$axios.put("/Oryx/FiscalDocumentType/Update", store.state.cv1 )
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/documentos-fiscais")
				store.state.cv1 = null
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async delete(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, {root: true})
			await this._vm.$axios.delete(`/Oryx/FiscalDocumentType/Delete/${store.state.cv1.cv1docfis}`)
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/documentos-fiscais")
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async findAll(store){
			store.state.loading = true
			store.commit("initForm")
			let payload = await this._vm.$axios.get("/Oryx/FiscalDocumentType/FindAll")
			.then(response => {
				return Utils.ValidateAxiosResponse(response.data);
			}).catch(error => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return []
			})
			store.state.loading = false
			return payload
		},
		async search(store, { limit = 20, page = 1}){
			store.state.loading = true
			store.commit("initForm")
			await this._vm.$axios.get(`/Oryx/FiscalDocumentType/Search?search=${store.state.search}&limit=${limit}&page=${page}`)
			.then(response => {
				let payload = Utils.ValidateAxiosResponse(response.data);
				store.commit("setParamsDataTable", payload)
			})
			.catch((error) => {
				store.state.lstCv1 = []
				store.state.search = ""
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
			});
			store.state.loading = false
		},
        async proximoNumero(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Procurando próximo número de documento", indeterminate: true }, {root: true})
            let lxd = store.rootState.lxd.lxd
			let payload = await this._vm.$axios.get(`/Oryx/FiscalDocumentType/ProximoNumero/${lxd.lxddoccre}`)
			.then(response => {
				return Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return null
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
            return payload
		},
		async findCv1modeloByCv1docfis ({ commit, dispatch }, cv1docfis){
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Procurando modelo de documento", indeterminate: true }, {root: true})
			let payload = await this._vm.$axios.get(`/Oryx/FiscalDocumentType/FindCv1modeloByCv1docfis/${cv1docfis}`)
			.then(response => {
				commit("setCv1modelo", Utils.ValidateAxiosResponse(response.data))
				return true
			})
			.catch((error) => {
				dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return payload
		},
	}
}